import { useEffect, useRef } from "react";

export default function HeroCanvas() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const ctx = canvas.getContext("2d");
    let raf;
    let w, h;
    const mouse = { x: 0.5, y: 0.5 };
    const GAP = 56;
    let dots = [];

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      w = canvas.width = rect.width;
      h = canvas.height = rect.height;
      dots = [];
      for (let x = 0; x < w + GAP; x += GAP) {
        for (let y = 0; y < h + GAP; y += GAP) {
          dots.push({ ox: x, oy: y, phase: Math.random() * Math.PI * 2 });
        }
      }
    };

    const onMove = (e) => {
      mouse.x = e.clientX / window.innerWidth;
      mouse.y = e.clientY / window.innerHeight;
    };

    let t = 0;
    const draw = () => {
      t += 0.008;
      ctx.clearRect(0, 0, w, h);
      const px = (mouse.x - 0.5) * 22;
      const py = (mouse.y - 0.5) * 22;
      for (const d of dots) {
        const drift = Math.sin(t + d.phase) * 4;
        const x = d.ox + px * (d.ox / w) + drift;
        const y = d.oy + py * (d.oy / h) + Math.cos(t + d.phase) * 4;
        const centerDist = Math.hypot(x - w / 2, y - h / 2) / (w / 2);
        const alpha = Math.max(0.03, 0.16 - centerDist * 0.13);
        ctx.beginPath();
        ctx.arc(x, y, 1.4, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${alpha})`;
        ctx.fill();
      }
      const grad = ctx.createRadialGradient(w * 0.75, h * 0.25, 0, w * 0.75, h * 0.25, w * 0.5);
      grad.addColorStop(0, "rgba(255,69,0,0.09)");
      grad.addColorStop(1, "rgba(255,69,0,0)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      className="absolute inset-0 h-full w-full pointer-events-none"
    />
  );
}
